import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faArrowRightFromBracket, faSpinner } from '@/fontawesome';
import { isImpersonating, getImpersonatedUserName, endImpersonation } from '@/services/impersonation';

export default function ImpersonationBar() {
  const [isEnding, setIsEnding] = useState(false);

  // Only render if impersonating
  if (!isImpersonating()) {
    return null;
  }

  const userName = getImpersonatedUserName() ?? 'Unbekannt';

  const handleEndImpersonation = () => {
    setIsEnding(true);
    endImpersonation();
    // Reload the page to refresh the entire app state with the admin's account
    window.location.href = '/admin/users';
  };

  return (
    <>
      {/* Red border around entire viewport */}
      <div className="fixed inset-0 z-[59] border-2 border-red-600 pointer-events-none" />

      {/* Top bar */}
      <div className="fixed top-0 left-0 right-0 z-[60] bg-red-600 text-white shadow-sm">
        <div className="flex items-center justify-between px-3 py-1">
          <div className="flex items-center space-x-2 text-sm">
            <FontAwesomeIcon icon={faExclamationTriangle} className="w-3 h-3" />
            <span>
              Eingeloggt als <span className="font-semibold">'{userName}'</span>
            </span>
          </div>
          <button
            onClick={handleEndImpersonation}
            disabled={isEnding}
            className="bg-white text-red-600 hover:bg-red-50 disabled:bg-gray-200 disabled:text-gray-400 px-2 py-0.5 rounded text-xs font-medium transition-colors flex items-center space-x-1 cursor-pointer disabled:cursor-not-allowed"
          >
            {isEnding ? (
              <FontAwesomeIcon icon={faSpinner} className="w-3 h-3 animate-spin" />
            ) : (
              <FontAwesomeIcon icon={faArrowRightFromBracket} className="w-3 h-3" />
            )}
            <span>Zurück</span>
          </button>
        </div>
      </div>
    </>
  );
}
